import { NgModule, importProvidersFrom } from '@angular/core';
import { CommonModule, NgClass } from '@angular/common';
import { PageLoaderComponent } from './layout/page-loader/page-loader.component';
import { DirectionService, RightSidebarService } from './core';
import { FeatherModule } from 'angular-feather';
import { allIcons } from 'angular-feather/icons';
import { MainLayoutComponent } from './layout/app-layout/main-layout/main-layout.component';
import { BarebonesLayoutComponent } from './layout/app-layout/barebones-layout/barebones-layout.component';
import { HeaderComponent } from './layout/header/header.component';
import { SidebarComponent } from './layout/sidebar/sidebar.component';
import { RightSidebarComponent } from './layout/right-sidebar/right-sidebar.component';
import { FeatherIconsComponent } from './shared/components/feather-icons/feather-icons.component';
import { BidiModule } from '@angular/cdk/bidi';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { NgScrollbar } from 'ngx-scrollbar';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { MatButtonToggleModule } from '@angular/material/button-toggle';



@NgModule({
  declarations: [
    PageLoaderComponent,
    MainLayoutComponent,
    BarebonesLayoutComponent,
    HeaderComponent,
    SidebarComponent,
    RightSidebarComponent,
    FeatherIconsComponent,
  ],
  imports: [
    CommonModule,
    FeatherModule,
    BidiModule,
    MatMenuModule,
    NgClass,
    MatButtonModule,
    MatButtonToggleModule,
    MatSlideToggleModule,
    NgScrollbar,
    LoadingBarModule,
    TranslateModule,
    RouterLinkActive,
    RouterLink,
    RouterOutlet
  ],
  providers: [
    DirectionService,
    RightSidebarService,
    importProvidersFrom(FeatherModule.pick(allIcons))
  ],
  exports: [
    PageLoaderComponent
  ]
})
export class LoraxModule { }
